import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classes from './MissingActivities.module.css';

const MissingActivities = () => {
  const { t } = useTranslation(['course']);
  const dataCourse = useSelector(state => state.courseInfo);
  let finishedVideoActivities = 0;
  let totalVideoActivities = 0;
  let finishedQuizzesActivities = 0;
  let totalQuizzesActivities = 0;
  let finishedCoevaluationActivities = 0;
  let totalCoevaluationActivities = 0;
  let finishedHomeworkActivities = 0;
  let totalHomeworkActivities = 0;
  if (dataCourse.lessonsCourse.separators) {
    dataCourse.lessonsCourse.separators.map(folder => {
      folder.lessons.map(video => {
        totalVideoActivities += 1;
        if (video.hasEvaluation) {
          totalHomeworkActivities += 1;
          totalCoevaluationActivities += 1;
        }
        if (video.idQuiz > 0) {
          totalQuizzesActivities += 1;
        }
      });
    });
  }
  if (dataCourse.lessonsCourse.lessons) {
    dataCourse.lessonsCourse.lessons.map(video => {
      totalVideoActivities += 1;
      if (video.hasEvaluation) {
        totalHomeworkActivities += 1;
        totalCoevaluationActivities += 1;
      }
      if (video.idQuiz > 0) {
        totalQuizzesActivities += 1;
      }
    });
  }
  dataCourse.userAditionalTrack.userTrack.map(progress => {
    if (progress.media_play == 2) {
      finishedVideoActivities += 1;
    }
    if (progress.media_eval == 2) {
      finishedHomeworkActivities += 1;
    }
    if (progress.media_coeval >= 3) {
      finishedCoevaluationActivities += 1;
    }
    if (progress.media_quiz == 2) {
      finishedQuizzesActivities += 1;
    }
  });
  return (
    <div className={classes.remainActivitiesContainer}>
      <p className={classes.itemContainer}>
        <figure className={classes.iconLessonContainer}>
          <img
            className={classes.img}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/Video_icon.png"
          />
        </figure>
        {totalVideoActivities - finishedVideoActivities === 0 ? (
          t('lessonsCompleted')
        ) : (
          <>
            {t('remain')}{' '}
            <span className={classes.number}>
              {totalVideoActivities - finishedVideoActivities}{' '}
            </span>
            {t('lessons')}
          </>
        )}
      </p>
      {totalHomeworkActivities > 0 && (
        <p className={classes.itemContainer}>
          <figure className={classes.iconLessonContainer}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/Actividad_icon.png"
            />
          </figure>
          {totalHomeworkActivities - finishedHomeworkActivities ===
          0 ? (
            t('activitiesCompleted')
          ) : (
            <>
              {t('remain')}{' '}
              <span className={classes.number}>
                {totalHomeworkActivities -
                  finishedHomeworkActivities}{' '}
              </span>
              {t('activities')}
            </>
          )}
        </p>
      )}
      {totalCoevaluationActivities > 0 && (
        <p
          className={classes.itemContainer}
          style={{
            marginRight:
              totalCoevaluationActivities -
                finishedCoevaluationActivities !==
              0
                ? '4%'
                : 0
          }}
        >
          <figure className={classes.iconLessonContainer}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/Coevaluacion_icon.png"
            />
          </figure>
          {totalCoevaluationActivities -
            finishedCoevaluationActivities ===
          0 ? (
            t('CoAssessmentsCompleted')
          ) : (
            <>
              {t('remain')}{' '}
              <span className={classes.number}>
                {totalCoevaluationActivities -
                  finishedCoevaluationActivities}{' '}
              </span>
              {t('peer_evaluations')}
            </>
          )}
        </p>
      )}
      {totalQuizzesActivities > 0 && (
        <p className={classes.itemContainerSpecial}>
          <figure className={classes.iconLessonContainer}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/Evaluacion_icon.png"
            />
          </figure>
          {totalQuizzesActivities - finishedQuizzesActivities ===
          0 ? (
            t('evaluationsCompleted')
          ) : (
            <>
              {t('remain')}{' '}
              <span className={classes.number}>
                {totalQuizzesActivities - finishedQuizzesActivities}{' '}
              </span>
              {t('assessments')}
            </>
          )}
        </p>
      )}
    </div>
  );
};

MissingActivities.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userTrack: PropTypes.object
};

export default MissingActivities;
